export default __webpack_public_path__ + "static/media/studying.ca6fc996.svg";